import type { PropsWithChildren } from 'react';

import { css, keyframes } from '@sorare/css';

export const unmountingDuration = 200;
const cardFadeOut = keyframes`
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  60% {
    opacity: 0;
  }
  100% {
    opacity: 0;
    transform: translateY(-30%);
  }
`;

const root = css`
  animation: ${unmountingDuration}ms ${cardFadeOut} ease-in-out forwards;
`;

export const UnmountingAnimation = ({ children }: PropsWithChildren) => (
  <div className={root}>{children}</div>
);
